"use client"

import { datadogRum } from "@datadog/browser-rum"
import { useSession } from "next-auth/react"
import { useEffect } from "react"
import { cn } from "src/lib/utils"
import { Button } from "src/orca/components/Button/Button"
import Icon from "src/orca/components/Icon/Icon"
import { usePageLoaded } from "src/store/page-status"

export type PageErrorProps = {
  error: Error & { digest?: string }
  reset?: () => void
  className?: string
}

export const PageError = ({ error, reset, className }: PageErrorProps) => {
  usePageLoaded()
  useEffect(() => {
    // temporary workaround, we don't need to log if reset is not present because
    // it means the error did not come from next.js and it was already logged
    if (reset) {
      datadogRum.addError(error)
    }
  }, [error, reset])
  const userOrgId = useSession().data?.organizationId

  return (
    <div className={cn("mt-[160px] flex justify-center font-medium", className)}>
      <div className="box-border gap-tokens-space-8 flex w-[320px] flex-col items-center rounded-tokens-16 border-tokens-1 border-tokens-border-general-border-02 p-tokens-space-16">
        <Icon name="Info" size={24} className="my-tokens-space-8" />
        <h2>{error.message || "Something went wrong!"}</h2>
        {error.name === "499" ? (
          <Button
            variant="secondary"
            onClick={() => location.replace("/settings/user?2FANotice=true")}
          >
            Go to settings page
          </Button>
        ) : (
          <>
            {userOrgId && (
              <Button variant="secondary" onClick={() => location.replace(`/org/${userOrgId}`)}>
                Go back to your organization
              </Button>
            )}
            <div className="flex gap-tokens-space-16">
              {reset && (
                <Button variant="secondary" onClick={() => reset()}>
                  Try again
                </Button>
              )}
              <Button variant="secondary" onClick={() => location.replace(location.pathname)}>
                Refresh
              </Button>
            </div>
          </>
        )}
      </div>
    </div>
  )
}
